import React, { useState, useRef, useEffect } from "react";
import { useNotificationContext } from "../../contexts/NotificationContext";
import NotificationModal from "./NotificationModal";

export default function NotificationDropdown() {

  const {
    notifications,
    unreadCount,
    markAsRead,
    deleteNotification
  } = useNotificationContext();

  const [open, setOpen] = useState(false);
  const [selectedNotif, setSelectedNotif] = useState(null);

  const wrapperRef = useRef(null);

  /* close dropdown outside click */

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);

  }, []);

  const openNotification = (notif) => {

    if (notif.status === "unread") {
      markAsRead(notif);
    }

    setSelectedNotif(notif);

  };

  const formatTime = (date) => {
    return new Date(date).toLocaleString();
  };

  return (
    <>
      <div
        className="notification-icon-wrapper"
        ref={wrapperRef}
      >

        <button
          className="notification-icon-btn"
          onClick={() => setOpen(prev => !prev)}
          aria-label="Notifications"
        >

          {unreadCount > 0 && (
            <span className="notification-badge">
              {unreadCount}
            </span>
          )}

          <i className="fa-solid fa-bell"></i>

        </button>

        {open && (

          <div className="notification-dropdown">

            {/* HEADER */}

            <div className="notification-header">

              <h4 className="notification-title-header">
                Notifications
              </h4>

              <button
                className="notification-close"
                onClick={() => setOpen(false)}
              >
                ×
              </button>

            </div>

            {/* LIST */}

            <div className="notification-list">

              {notifications.length === 0 && (
                <div className="notification-empty">
                  No notifications
                </div>
              )}

              {notifications.map((notif) => {

                const isUnread = notif.status === "unread";

                return (

                  <div
                    key={notif.id}
                    className={`notification-item
                      ${isUnread ? "unread" : "read"}
                      value-${notif.notification?.value || 1}
                    `}
                    onClick={() => openNotification(notif)}
                  >

                    {/* UNREAD DOT */}

                    {isUnread && (
                      <span className="notification-dot" />
                    )}

                    {/* CONTENT */}

                    <div className="notification-content">

                      <p className="notification-title">
                        {notif.notification?.title}
                      </p>

                      <span className="notification-time">
                        {formatTime(
                          notif.notification?.createdAt
                        )}
                      </span>

                    </div>

                    {/* ACTIONS */}

                    <div
                      className="notification-actions"
                      onClick={(e) => e.stopPropagation()}
                    >

                      {isUnread && (

                        <button
                          className="notification-read"
                          onClick={() => markAsRead(notif)}
                          title="Mark as read"
                        >
                          ✓
                        </button>

                      )}

                      <button
                        className="notification-delete"
                        onClick={() => deleteNotification(notif)}
                        title="Delete"
                      >
                        ×
                      </button>

                    </div>

                  </div>

                );

              })}

            </div>

          </div>

        )}

      </div>

      {selectedNotif && (

        <NotificationModal
          notification={selectedNotif.notification}
          onClose={() => setSelectedNotif(null)}
        />

      )}
    </>
  );
}